import React from 'react';
import { refundRequestReason, typeOfStudent } from '../../../../utils/constants/GlobalStaticData';
import { Autocomplete, Box, Button, Grid, TextField } from '@mui/material';
import { KeyboardArrowUp, KeyboardArrowDown, Login } from '@mui/icons-material';
import { motion, AnimatePresence } from 'framer-motion';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { useSelector } from 'react-redux';

const roles = [
  { id: 1, name: 'OGA' },
  { id: 2, name: 'CRO' },
];
// Finance (expense_accountant_approval) status; -1 = All (no filter sent)
const financeStatuses = [
  { id: -1, name: 'All' },
  { id: 1, name: 'Approved' },
  { id: 2, name: 'Non Approved' },
];
const FilterSection = ({
  showFilters,
  setShowFilters = () => {},
  selectedType,
  setSelectedType,
  projectId,
  setProjectId,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  filterSubmit = () => {},
  loading = false,
  selectedReason,
  setSelectedReason,
  selectedCro,
  setSelectedCro,
  selectedOga,
  setSelectedOga,
  croList = [],
  ogaList = [],
  selectedRole,
  setSelectedRole,
  selectedFinanceStatus,
  setSelectedFinanceStatus,
}) => {
  const { projectslist, loading: projectLoading } = useSelector((state) => state.refund);
  const mainLoading = loading || projectLoading;

  return (
    <Box>
      <Box display="flex" justifyContent="flex-start" gap={1} mb={1}>
        <Button
          endIcon={showFilters ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          size="medium"
          variant="outlined"
          onClick={() => setShowFilters((prev) => !prev)}
          sx={{
            minWidth: 150,
            // borderRadius: '12px',
            textTransform: 'none',
            boxShadow: 'none',
          }}
        >
          {showFilters ? 'Hide Filters' : 'Show Filters'}
        </Button>
        {showFilters && (
          <Button
            disabled={mainLoading}
            endIcon={<Login />}
            size="medium"
            type="submit"
            variant="outlined"
            onClick={() => filterSubmit()}
            sx={{
              minWidth: 150,
              // borderRadius: '12px',
              textTransform: 'none',
              boxShadow: 'none',
            }}
          >
            Submit
          </Button>
        )}
      </Box>
      <AnimatePresence initial={false}>
        {showFilters && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: 'easeInOut' }}
            style={{ overflow: 'hidden' }}
          >
            <Grid container spacing={1} my={1}>
              {/* Date Filter - Conditional Rendering */}
              {Boolean(setFromDate) && Boolean(setToDate) && (
                <Grid item xs={12} md={6} lg={4}>
                  <FromAndToDatePicker
                    disabled={false}
                    fromDate={fromDate}
                    toDate={toDate}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                    fullWidth={true}
                  />
                </Grid>
              )}

              {/* Student Type Filter - Conditional Rendering */}
              {Boolean(setSelectedType) && (
                <Grid item xs={12} md={6} lg={4}>
                  <GlobalSelectFieldWithoutFormikNew
                    keys={{ itemId: 'id', itemValue: 'name' }}
                    data={typeOfStudent}
                    label={'Student Type'}
                    fullWidth={true}
                    selectedDetails={selectedType}
                    setChange={setSelectedType}
                  />
                </Grid>
              )}

              {/* Project Filter - Conditional Rendering */}
              {Boolean(setProjectId) && (
                <Grid item xs={12} md={6} lg={4}>
                  <Autocomplete
                    name={'projectId'}
                    fullWidth
                    options={Array.isArray(projectslist) ? projectslist : []}
                    getOptionLabel={(option) => option.name || ''}
                    value={
                      Array.isArray(projectslist) ? projectslist?.find((data) => data?.id == projectId) || null : null
                    }
                    onChange={(e, option) => setProjectId(option?.id)}
                    renderInput={(params) => <TextField fullWidth autoComplete="off" {...params} label="Projects" />}
                  />
                </Grid>
              )}

              {Boolean(setSelectedCro) && (
                <Grid item xs={12} md={6} lg={4}>
                  <GlobalSelectFieldWithoutFormikNew
                    disabled={!projectId}
                    keys={{ itemId: 'userID', itemValue: 'name' }}
                    data={croList}
                    label={'CRO'}
                    fullWidth={true}
                    selectedDetails={selectedCro}
                    setChange={setSelectedCro}
                  />
                </Grid>
              )}

              {Boolean(setSelectedOga) && (
                <Grid item xs={12} md={6} lg={4}>
                  <GlobalSelectFieldWithoutFormikNew
                    disabled={!projectId}
                    keys={{ itemId: 'userID', itemValue: 'name' }}
                    data={ogaList}
                    label={'OGA'}
                    fullWidth={true}
                    selectedDetails={selectedOga}
                    setChange={setSelectedOga}
                  />
                </Grid>
              )}

              {Boolean(setSelectedReason) && (
                <Grid item xs={12} md={6} lg={4}>
                  <GlobalSelectFieldWithoutFormikNew
                    keys={{ itemId: 'id', itemValue: 'reason' }}
                    data={refundRequestReason}
                    label={'Reason'}
                    fullWidth={true}
                    selectedDetails={selectedReason}
                    setChange={setSelectedReason}
                  />
                </Grid>
              )}

              {Boolean(setSelectedRole) && (
                <Grid item xs={12} md={6} lg={4}>
                  <GlobalSelectFieldWithoutFormikNew
                    keys={{ itemId: 'id', itemValue: 'name' }}
                    data={roles}
                    label={'Roles'}
                    fullWidth={true}
                    selectedDetails={selectedRole}
                    setChange={setSelectedRole}
                  />
                </Grid>
              )}

              {Boolean(setSelectedFinanceStatus) && (
                <Grid item xs={12} md={6} lg={4}>
                  <GlobalSelectFieldWithoutFormikNew
                    keys={{ itemId: 'id', itemValue: 'name' }}
                    data={financeStatuses}
                    label={'Finance Status'}
                    fullWidth={true}
                    selectedDetails={selectedFinanceStatus}
                    setChange={setSelectedFinanceStatus}
                  />
                </Grid>
              )}
            </Grid>
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
};

export default React.memo(FilterSection);
